<template>
  <main>
    <div class="certified-courses">
      <div class="section-frame" v-if="certificatedData">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/certified-courses">{{
              certificatedData.name
            }}</router-link>
          </li>
        </ul>
        <div class="page-sub-title">
          <h1>
            <i class="fa-title"></i><i>{{ certificatedData.name }}</i>
          </h1>
        </div>
        <div class="certified-courses-title">
          <div class="courses-title-frame">
            <i class="fa-title"></i>
            <h2>{{ $t("certificated_courses") }}</h2>
          </div>
          <p>
            <span
              v-if="certificatedData.quiz && certificatedData.quiz.is_blocked"
            >
              {{ $t("need_complete_all_courses") }}
            </span>
            <span
              v-else-if="
                certificatedData.quiz &&
                !certificatedData.quiz.completed &&
                !certificatedData.quiz.is_blocked
              "
            >
              {{ $t("courses_completed_take_test") }}
            </span>
            <span
              v-else-if="
                certificatedData.quiz && certificatedData.quiz.completed
              "
            >
              {{ $t("test_passed_successfully") }}
              <a
                href="#!"
                style="margin: 10px auto"
                class="courses-test-reply success"
                @click.prevent
                >{{ $t("test_passed") }}
              </a>
            </span>
            <span v-else-if="!certificatedData.quiz">
              {{ $t("test_not_created") }}
            </span>
            <span v-else>{{ $t("course_loading") }}</span>
          </p>
        </div>

        <div class="courses-list" v-if="certificated">
          <CoursesCard
            v-for="(course, index) in certificated.result"
            :data="course"
            :key="index"
          />
        </div>
        <div v-else class="courses-list loading">
          <v-loader />
        </div>
      </div>

      <div
        v-if="
          certificatedData &&
          certificatedData.quiz &&
          !certificatedData.quiz.completed &&
          !certificatedData.quiz.is_blocked
        "
        class="certified-descripter"
      >
        <div class="section-frame">
          <div class="descripter-content">
            <img
              src="../../assets/images/certified-course.jpg"
              class="descripter-photo"
              alt=""
            />
            <div class="descripter-info">
              <div class="page-sub-title">
                <h2>
                  <i class="fa-title"></i><i>{{ $t("in_progress") }}</i>
                </h2>
              </div>
              <p>
                <span>{{ $t("certificate_description") }}</span>
              </p>
              <router-link
                :to="`/certificated-test/${certificatedData.quiz.slug}`"
                class="certified-desc"
                ><div>{{ $t("start_test") }}</div>
                <i class="fa-arrow-line"></i
              ></router-link>
            </div>
          </div>
          <router-link
            :to="`/certificated-test/${certificatedData.quiz.slug}`"
            class="certified-mob-page"
            ><div>{{ $t("start_test") }}</div>
            <i class="fa-arrow-line"></i
          ></router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CoursesCard from "@/components/CoursesCard";

export default {
  beforeCreate() {
    console.log(
      "Certified.vue - beforeCreate, route params:",
      this.$route.params.id,
    );
    this.$store.dispatch("getCertificated", this.$route.params.id);
    this.$store
      .dispatch("getCertificatedData", this.$route.params.id)
      .then(() => {
        console.log(
          "CertificatedData loaded:",
          this.$store.getters.getCertificatedData,
        );
      });
  },
  computed: {
    certificated() {
      return this.$store.getters.getCertificated;
    },
    certificatedData() {
      return this.$store.getters.getCertificatedData;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
  methods: {
    async pushCart(id) {
      if (localStorage.getItem("access")) {
        let obj = {
          courses: [id],
        };
        await this.$store.dispatch("addCart", obj);
        await this.hasWish();
      } else {
        await this.$store.commit("setError", "no-auth");
        await this.$router.push("/login");
      }
    },
  },
  components: { CoursesCard },
};
</script>
